import React from 'react'
import { FaPlus } from 'react-icons/fa'

const Dashboard = () => {
  return (
    <div className='flex flex-row items-center '>
      <h1 className="text-2xl md:text-3xl font-bold text-blue-600 mb-5">
        Dashboard
      </h1>

      {/* <button
        type="button"
        className=" w-fit px-3 py-2 mx-3 mb-4 tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
      >
        <FaPlus className="w-3 h-3" />
      </button> */}
    </div>
  )
}

export default Dashboard